import React from 'react';
import PropTypes from 'prop-types';
import GridCell from './gridCell/GridCell';
import './Grid.css';

export default function Grid({ letters = [] }) {
    const gridArray = Array.from(new Array(5 * 6));
    return (
        <ul className="grid-container">
            {gridArray.map((key, index) => {
                return (
                    <GridCell
                        key={index}
                        index={index}
                        letterObject={letters[index]}
                    />
                )
            })}
        </ul>
    );
}

Grid.defaultProps = {
    letters: [],
};

Grid.propTypes = {
    letters: PropTypes.instanceOf(Array),
};
